<template>
    <div>
        <section class="content-header">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-6">
                        <h3>{{ $t('label.driver') }}</h3>
                    </div>
                    <div class="col-md-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><router-link to="/">{{ $t("label.home")}}</router-link></li>
                            <li class="breadcrumb-item active">{{ $t("label.driver")}}</li>
                        </ol>
                    </div>
                </div>
            </div>
        </section>
        <div class="content">
            <div class="container-fluid">

                <!-- <div class="callout callout-success">
                    <br>
                    <workflow-process />
                </div> -->

                <div class="card card-default">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-md-6 col-6">
                                <h3 class="card-title mt-1">{{ $t("label.driver")}}</h3>
                            </div>
                            <div class="col-md-6 col-6 text-right">
                                <router-link class="btn btn-sm btn-primary" to="/driver/create">
                                    <fa :icon="fas.faPlus" /> {{ $t('label.create') }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-4">
                                <div class="input-group">
                                    <input @keyup.enter="getDrivers(1)" type="text" class="form-control" autofocus v-model="search" :placeholder="$t('label.search')">
                                    <div @click="getDrivers(1)" class="input-group-append cursor-pointer">
                                        <span class="input-group-text">
                                            <fa :icon="fas.faSearch"/>
                                        </span>                                
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="drivers.length > 0" class="table-responsive">
                            <table class="table table-bordered mb-0">
                                <tbody>
                                    <tr>
                                        <th nowrap style="width: 1%;"></th>
                                        <th>{{ $t('label.last_name') }}</th>
                                        <th>{{ $t('label.first_name') }}</th>
                                        <th>{{ $t('label.gender') }}</th>
                                        <th>{{ $t('label.nationality') }}</th>
                                        <th>{{ $t('label.identity_number') }}</th>
                                        <th>{{ $t('label.passport_number') }}</th>
                                        <th nowrap style="width: 1%;"></th>
                                    </tr>
                                    <tr v-for="(driver, index) in drivers" :key="index">
                                        <td>{{ index + 1}}</td>
                                        <td>{{ driver.last_name }}</td>
                                        <td>{{ driver.first_name }}</td>
                                        <td>{{ driver.gender.toUpperCase() }}</td>
                                        <td>{{ driver.nationality }}</td>
                                        <td>{{ driver.identity_card_number }}</td>
                                        <td>{{ driver.passport_number }}</td>
                                        <td>
                                            <router-link v-if="getPermission('tempvehicle.driver.view')" :to="{ name: 'ViewDriver', params: { id: driver.uuid }}" class="mr-1" :title="$t('label.view')">
                                                <fa :icon="fas.faEye"/>
                                            </router-link>
                                            <router-link v-if="getPermission('tempvehicle.driver.edit')" :to="{ name: 'EditDriver', params: { id: driver.uuid }}" class="mr-1" :title="$t('label.edit')">
                                                <fa :icon="fas.faEdit" style="color: green;"/>
                                            </router-link>
                                            <a v-if="getPermission('tempvehicle.driver.delete')" v-on:submit.prevent @click="destroy(driver)" :title="$t('label.delete')" href="javascript:void(0)">
                                                <fa :icon="fas.faTrash" style="color: red;"/>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div v-if="drivers.length > 0">
                              <paginate class="pagination-sm mb-0"
                                        :page-count="last_page"
                                        :force-page="forcePage"
                                        :page-range="3"
                                        :margin-pages="2"
                                        :click-handler="getDrivers"
                                        :container-class="'pagination float-right'"
                                        :prev-text="'Prev'"
                                        :prev-class="'page-item'"
                                        :next-text="'Next'"
                                        :next-class="'page-item'"
                                        :page-class="'page-item'"
                                        :active-class="'active'"
                                        :prev-link-class="'page-link'"
                                        :next-link-class="'page-link'"
                                        :page-link-class="'page-link'"
                                        ref="driver">
                              </paginate>
                            </div>
                        </div>
                        <div class="callout callout-success" v-else>
                            <label>{{$t('label.no_data')}}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { fas } from "@fortawesome/free-solid-svg-icons";
export default {
    name: "Drivers",
    data() {
        return {
          baseURI: "",
          drivers: [],
          search: '',
          forcePage: 1,
          last_page: 0,
        }
    },
    computed: {
        fas() {
            return fas;
        },
        // filteredDrivers(){
        //     return this.drivers.filter(driver => {
        //         let search = this.search.toLowerCase();
        //         return driver.first_name.toLowerCase().includes(search)
        //             || driver.last_name.toLowerCase().includes(search)
        //             || driver.nationality.toLowerCase().includes(search)
        //     });
        // }
    },
    mounted() {
        this.getDrivers();
    },
    methods: {
        getDrivers(pageNumber = 1) {
          this.$store.state.loading.status = true;
          this.forcePage = pageNumber;
          this.forcePage = pageNumber;
          let url = this.baseURI + 'drivers?page=' + pageNumber + '&per_page=' + 10;
          if(this.search){
            url = url + '&search=' + this.search;
          }
          GDCE_Client.requestApi("GET", url).then(response => {
            this.drivers = response.data.data;
            this.last_page = response.data.last_page;
            this.$store.state.loading.status = false;
          });
        },
        destroy(driver) {
            this.$swal({
                title: this.$t('label.confirm_delete'),
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((willDelete) => {
                if (willDelete) {
                    this.$store.state.loading.status = true;
                    let url = this.baseURI+'/drivers/'+ driver.uuid;
                    GDCE_Client.requestApi("DELETE",url).then(response => {
                        this.$store.state.loading.status = false;
                        this.getDrivers();
                    }).catch(error => {
                        this.$store.state.loading.status = false;
                    });
                }
            });
        },
        getPermission(permission = ''){
            return this.$hasPermission(permission) ? true : false;
        }
    }
}
</script>
<style scoped>
table tbody tr td,
table thead tr th {
    white-space: nowrap;
    word-wrap: normal;
}
table tbody tr td a, table tr td a {
    display: inline;
    white-space: nowrap;
    padding-left: 5px;
}
</style>